import Chart from "react-apexcharts";

const PaymentBarChart = (props: any) => {
    const { data } = props;
    console.log(data)
    const categories = data?.map(
        (item: any) => item.payment_for
    );

    // For bar values  
    const totalCounts = data?.map(
        (item: any) => Number(item.total_count)
    );

    const totalAmounts = data?.map(
        (item: any) => Number(item.total_amount_sum)
    );

    const chartOptions: any = {
        chart: {
            type: "bar",
            height: 400,
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "55%",
                borderRadius: 6,
                borderRadiusApplication: "end",
                borderRadiusWhenStacked: "last",
            },
        },
        stroke: {
            width: [0, 0],
        },
        dataLabels: {
            enabled: true,
        },
        xaxis: {
            categories: categories,
        },

        yaxis: [
            {
                title: {
                    text: "Amount (৳)",
                },
            },
            {
                opposite: true,
                title: {
                    text: "Number of Payers",
                },
            },
        ],

        colors: ["#16F596", "#E86FB1"], // green + blue
        legend: {
            position: "top",
        },
    };

    const chartSeries = [
        {
            name: "Amount",
            data: totalAmounts,
            type: "bar",
        },
        {
            name: "Number of Payers",
            data: totalCounts,
            type: "bar",
        },
    ];

    return (
        <div className="card p-3 shadow-sm">
            <Chart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={350}
            />
        </div>
    );
};

export default PaymentBarChart;
